import { render, staticRenderFns } from "./parallax.global.vue?vue&type=template&id=1615e662&"
import script from "./parallax.global.vue?vue&type=script&lang=js&"
export * from "./parallax.global.vue?vue&type=script&lang=js&"
import style0 from "./parallax.global.vue?vue&type=style&index=0&id=1615e662&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports